<template>
<Transition name="modal">
<div v-if="show" class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container-LastxAlert">
          <div class="modal-header">
          <slot name="header">
              <button class="btn btn-outline-primary"
              color="darkgreen" size="small" type="border" icon="close"
              @click="$emit('close')"
              >Cerrar</button>
          </slot>
          </div>

          <div class="modal-body">
              <slot name="body">
              </slot>
          </div>
      </div>
    </div>
</div>
</Transition>
</template>

<script>
export default {
  name: 'ModalLastxAlerts',
  props: {
    show: Boolean,
  }
}
</script>

<style>
.btn-outline-primary {
    color: darkgreen;
    background-color: transparent;
    background-image: none;
    border-color: darkgreen;
    border-radius: 4px !important;
}

.btn-outline-primary:hover {
    color: white;
    background-color: darkgreen;
    border-color: darkgreen
}

.btn-outline-primary:focus,
.btn-outline-primary.focus {
    box-shadow: none !important;
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
    color: darkgreen;
    background-color: transparent
}

.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show>.btn-outline-primary.dropdown-toggle {
    color: white;
    background-color: darkgreen;
    border-color: darkgreen
}

.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-primary.dropdown-toggle:focus {
    box-shadow: none !important;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container-LastxAlert {
  width: 70%;
  height: 85%;
  margin: 0px auto;
  margin-top: 70px;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-header{
  justify-content: right;
}

.modal-body {
  /* margin: 20px 0; */
  width: 100%;
  height: 100%;
  text-align: center;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container-LastxAlert,
.modal-leave-to .modal-container-LastxAlert {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>